/**
 * Creates deferred promise which you can use as parameter and resolve, reject using functions
 *
 * e.g.:
 *
 * const [promise, resolve, reject] = deferredPromise()
 *
 * Promise.all([
 *  something(promise),
 *  ...
 * ]).then(resolve, reject)
 *
 */

type PromiseFunc<T> = (value?: T | PromiseLike<T>) => void

const deferredPromise = <T = any>(): [ Promise<T>, PromiseFunc<T>, PromiseFunc<T> ] => {
  let resolvePromise = () => undefined
  let rejectPromise = () => undefined

  const promise = new Promise<T>((resolve, reject) => {
    resolvePromise = resolve
    rejectPromise = reject
  })

  return [ promise, resolvePromise, rejectPromise ]
}


export default deferredPromise
